import React from "react";
import Box from "@mui/material/Box";
import { useStyles } from "./style";
import { getSlotsCountByDay } from "../../AutoReschedule/helper";
import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from "../../Shared/Carousel/Carousel";
import { useMediaQuery } from "@mui/material";

const formatDate = (date) => {
  const dateObj = new Date(date);
  return {
    weekday: dateObj.toLocaleString("default", { weekday: "short" }),
    month: dateObj.toLocaleString("default", { month: "short" }),
    day: dateObj.getDate(),
  };
};

export const DateButton = ({
  date,
  index,
  isSelected,
  slotsCount,
  onClick,
}) => {
  const classes = useStyles();
  const { weekday, month, day } = formatDate(date);

  const getButtonClassName = () => {
    if (slotsCount.totalSlots === 0) return classes.disabledBtn;
    return isSelected ? classes.activeBtn : classes.inactiveBtn;
  };

  return (
    <button
      type="button"
      className={getButtonClassName()}
      onClick={() => onClick(index, date)}
      disabled={slotsCount.totalSlots === 0}
    >
      <div
        className={classes.day}
        style={{ fontWeight: isSelected ? "600" : "400" }}
      >
        {weekday}
      </div>
      <div
        className={classes.date}
        style={{ fontWeight: isSelected ? "600" : "400" }}
      >
        {day}
      </div>
      <div
        className={classes.date}
        style={{ fontWeight: isSelected ? "600" : "400" }}
      >
        {month}
      </div>
    </button>
  );
};

export const DateSlots = ({
  nextSevenDays,
  allSlots,
  selectedButton,
  handleOnClick,
}) => {
  const classes = useStyles();
  const matchesMD = useMediaQuery("(max-width:599px)");

  if (!nextSevenDays?.length) {
    return null;
  }

  return (
    <div>
      <Carousel
        opts={{
          align: "start",
        }}
        className={classes.dayBox}
      >
        {matchesMD && (
          <>
            <CarouselPrevious
              autoHideBtn={false}
              sxStyles={{
                position: "relative",
                display: "flex",
                alignItem: "center",
                height: "auto",
              }}
            />
          </>
        )}
        <CarouselContent className={classes.carouselContainer}>
          {nextSevenDays.map((date, index) => {
            const slotsCount = getSlotsCountByDay(date, allSlots);
            const unOccupiedSlots =
              slotsCount?.freeSlots + slotsCount?.onRequestSlots;

            return (
              <div
                key={`date-slot-${date}-${index}`}
                className={classes.dateSlotCard}
              >
                <div>
                  <DateButton
                    date={date}
                    index={index}
                    isSelected={selectedButton === index}
                    slotsCount={slotsCount}
                    onClick={handleOnClick}
                  />
                </div>
                <Box
                  className={
                    unOccupiedSlots > 0 ? classes.slotsNumber : classes.noSlots
                  }
                >
                  {`${unOccupiedSlots} slots`}
                </Box>
              </div>
            );
          })}
        </CarouselContent>
        {matchesMD && (
          <>
            <CarouselNext
              autoHideBtn={false}
              sxStyles={{
                position: "relative",
                display: "flex",
                alignItem: "center",
                height: "auto",
              }}
            />
          </>
        )}
      </Carousel>
    </div>
  );
};
